export default {
  title: 'CSV de reservas',
  buttons: {
    generate: 'Generar y descargar',
  },
  fields: {
    date_range: 'Rango de fechas (opcional)',
  },
  errors: {
    invalid_date_range: 'Por favor, selecciona un rango de fechas válido',
  },
};
